const $ = require("jquery");

module.exports = function whenButtonsVideoPopupClosesStopVideo(){
    // Trigger event when button's modal is closed
    $('.itbl-c-buttons__video-popup').on('closed.zf.reveal', function () {
        var modal = $(this);

        // Stop youtube video
        var iframe = modal.find('iframe');
        var videoSrc = iframe.attr('src');
        iframe.attr('src', '');
        iframe.attr('src', videoSrc);

        // Stop video
        var video = modal.find('video');
        if(video.length > 0){
            video[0].pause();
            video[0].currentTime = 0;
        }

        // Hide overlay
        $('.reveal-overlay').hide();
    });

    $('#secondary_demo').on('closed.zf.reveal', function () {
        $('.reveal-overlay').hide();
    });
}